<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('CASA_DE_REPOUSO_VENDA_RESIDENTE')"
          :class="[
            'nav-link link-nav-resident',
            step == 'CASA_DE_REPOUSO_VENDA_RESIDENTE' && 'active',
          ]"
          id="nav-rest-home-sale-resident"
          data-toggle="tab"
          href="#rest-home-sale-resident"
          role="tab"
          aria-controls="rest-home-sale-resident"
          aria-selected="true"
          >VENDA DA EMPRESA PARA O RESIDENTE</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'CASA_DE_REPOUSO_VENDA_RESIDENTE'"
        :class="[
          'tab-pane fade',
          step == 'CASA_DE_REPOUSO_VENDA_RESIDENTE' && 'show active',
        ]"
        id="rest-home-sale-resident"
        role="tabpanel"
        aria-labelledby="nav-rest-home-sale-resident"
      >
        <rest-home-sale-resident :resident="resident" />
      </div>
    </div>
  </div>
</template>

<script>
import RestHomeSaleResident from "./menu-rest-home-sale-resident/menu-rest-home-sale-resident.vue";

import routes from "../../../routes";

export default {
  name: "MenuRestHomeSaleResident",

  components: {
    RestHomeSaleResident,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "CASA_DE_REPOUSO_VENDA_RESIDENTE",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newNav;

      if (step == "CASA_DE_REPOUSO_VENDA_RESIDENTE") {
        newNav = "rest-home-sale-resident";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "rest-home-sale-resident") {
          this.step = "CASA_DE_REPOUSO_VENDA_RESIDENTE";
        }
      }
    },
  },
};
</script>